export default __webpack_public_path__ + "static/media/Colors.144f82dd.jpg";